import React, { useState, useEffect } from 'react'
import { Modal, SegmentedToggle, TextField, TextArea, Button, Banner } from '../../ui'

const TYPE_OPTIONS = [
  { value: 'bug', label: 'Bug report' },
  { value: 'feature', label: 'Feature request' },
  { value: 'other', label: 'Other' },
]

export function FeedbackModal({ open, onClose, onSubmit }) {
  const [type, setType] = useState('bug')
  const [subject, setSubject] = useState('')
  const [description, setDescription] = useState('')
  const [status, setStatus] = useState('idle')
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    if (!open) {
      setType('bug')
      setSubject('')
      setDescription('')
      setStatus('idle')
      setErrorMsg('')
    }
  }, [open])

  useEffect(() => {
    if (status === 'success') {
      const timer = setTimeout(onClose, 2500)
      return () => clearTimeout(timer)
    }
  }, [status, onClose])

  const canSubmit = type && subject.trim() && description.trim().length >= 20

  async function handleSubmit(e) {
    e.preventDefault()
    if (!canSubmit) return
    setStatus('loading')
    setErrorMsg('')
    try {
      await onSubmit(type, subject.trim(), description.trim())
      setStatus('success')
    } catch {
      setErrorMsg('Something went wrong. Please try again.')
      setStatus('error')
    }
  }

  return (
    <Modal open={open} onClose={onClose} title="Send Feedback" width="md">
      {status === 'success' ? (
        <Banner tone="success">Thanks for your feedback!</Banner>
      ) : (
        <form onSubmit={handleSubmit} style={styles.form}>
          <SegmentedToggle
            options={TYPE_OPTIONS}
            value={type}
            onChange={setType}
            ariaLabel="Feedback type"
          />
          <TextField
            label="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value.slice(0, 100))}
            placeholder="Brief summary"
            required
          />
          <TextArea
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value.slice(0, 1000))}
            placeholder="Describe your feedback in detail..."
            required
            rows={5}
            error={description.length > 0 && description.trim().length < 20 ? 'Minimum 20 characters' : undefined}
          />
          {status === 'error' && <Banner tone="error">{errorMsg}</Banner>}
          <div style={styles.actions}>
            <Button variant="primary" type="submit" loading={status === 'loading'} disabled={!canSubmit}>
              Send Feedback
            </Button>
          </div>
        </form>
      )}
    </Modal>
  )
}

const styles = {
  form: { display: 'flex', flexDirection: 'column', gap: 'var(--space-3)' },
  actions: { display: 'flex', justifyContent: 'flex-end', paddingTop: 'var(--space-2)' },
}
